import fundBalance from '../../views/fund/balance/fund-balance.vue';
import fundBalanceSure from '../../views/fund/balance/balance-sure.vue';
import fundBalanceFail from '../../views/fund/balance/balance-fail.vue';
import fundBalanceResult from '../../views/fund/balance/balance-result.vue';
var fundBalanceManage = [
    {
        name: 'fundBalance',
        path: 'fund-balance',
        component: fundBalance,
    },
    {
        name: 'fundBalanceSure',
        path: 'fund-balance-sure',
        component: fundBalanceSure,
    },
    {
        name: 'fundBalanceFail',
        path: 'fund-balance-fail',
        component: fundBalanceFail,
    },
    {
        name: 'fundBalanceResult',
        path: 'fund-balance-result',
        component: fundBalanceResult,
    },
];
export default fundBalanceManage;
